export const techReports = [
  {
    id: "copper-coupon-report",
    title: "銅クーポン ガス腐食試験結果報告書",
    author: "ファクトケイ株式会社",
    category: "試験レポート",
    pdfUrl: "https://www.factk.jp/factk/pdf/Report_CopperCoupon.pdf",
    summary: "銅クーポンを用いたガス腐食試験の結果をまとめた報告書です。硫化水素（H2S）および二酸化イオウ（SO2）を中心とした混合ガス環境下での銅の腐食挙動を、重量変化・接触抵抗変化・表面SEM観察の3つの観点から評価しました。試験条件ごとの腐食速度比較データも掲載しています。",
    contentHtml: `
      <div class="space-y-6">
        <div>
          <h3 class="text-lg font-bold text-foreground-900 mb-3">試験の目的</h3>
          <p class="text-foreground-700 leading-relaxed mb-3">
            本報告書は、銅クーポン（純銅試験片）を用いたガス腐食試験の結果をまとめたものです。電子部品の接点材料として広く使用される銅の腐食挙動を、加速試験環境下で定量的に評価することを目的としています。
          </p>
          <p class="text-foreground-700 leading-relaxed">
            試験は硫化水素（H2S）および二酸化イオウ（SO2）を中心とした混合ガス環境で実施し、腐食生成物の同定、重量変化、接触抵抗の推移を総合的に分析しました。
          </p>
        </div>

        <div>
          <h3 class="text-lg font-bold text-foreground-900 mb-3">試験条件</h3>
          <div class="overflow-x-auto">
            <table class="w-full text-sm border-collapse mb-3">
              <thead>
                <tr class="bg-background-100">
                  <th class="border border-background-200 px-4 py-2 text-left text-foreground-900 font-semibold">項目</th>
                  <th class="border border-background-200 px-4 py-2 text-left text-foreground-900 font-semibold">条件</th>
                </tr>
              </thead>
              <tbody class="text-foreground-700">
                <tr>
                  <td class="border border-background-200 px-4 py-2 font-medium">試験片</td>
                  <td class="border border-background-200 px-4 py-2">純銅クーポン（99.9%以上）30×30×0.3mm</td>
                </tr>
                <tr>
                  <td class="border border-background-200 px-4 py-2 font-medium">前処理</td>
                  <td class="border border-background-200 px-4 py-2">アセトン脱脂 → 純水洗浄 → 乾燥（室温）</td>
                </tr>
                <tr>
                  <td class="border border-background-200 px-4 py-2 font-medium">試験ガス</td>
                  <td class="border border-background-200 px-4 py-2">H2S 3ppm + SO2 10ppm + NO2 2ppm（混合）</td>
                </tr>
                <tr>
                  <td class="border border-background-200 px-4 py-2 font-medium">温湿度</td>
                  <td class="border border-background-200 px-4 py-2">温度 40℃ / 湿度 80%RH</td>
                </tr>
                <tr>
                  <td class="border border-background-200 px-4 py-2 font-medium">試験時間</td>
                  <td class="border border-background-200 px-4 py-2">24h / 48h / 96h / 168h（4水準）</td>
                </tr>
                <tr>
                  <td class="border border-background-200 px-4 py-2 font-medium">評価項目</td>
                  <td class="border border-background-200 px-4 py-2">重量変化、接触抵抗変化、表面SEM観察、EDS元素分析</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <div>
          <h3 class="text-lg font-bold text-foreground-900 mb-3">試験結果サマリー</h3>
          
          <h4 class="text-base font-semibold text-foreground-900 mt-4 mb-2">1. 重量変化</h4>
          <p class="text-foreground-700 leading-relaxed mb-3">
            銅クーポンの重量は試験時間に比例して増加し、168時間後には初期重量に対し約0.8%の増加が確認されました。これは表面に生成されたCu2S（硫化銅）およびCuSO4（硫酸銅）の蓄積によるものです。24時間後から既に明確な重量増加が観測され、腐食反応が初期段階から進行していることが示されました。
          </p>

          <h4 class="text-base font-semibold text-foreground-900 mt-4 mb-2">2. 接触抵抗変化</h4>
          <p class="text-foreground-700 leading-relaxed mb-3">
            4端子法による接触抵抗測定では、試験時間の経過とともに抵抗値の上昇が認められました。特に48時間を超えると上昇率が加速し、168時間後には初期値の約15倍の接触抵抗値を示しました。これは腐食生成物であるCu2Sが半導体的性質を持ち、接触界面での導通を阻害しているためと考えられます。
          </p>

          <h4 class="text-base font-semibold text-foreground-900 mt-4 mb-2">3. 表面SEM観察</h4>
          <p class="text-foreground-700 leading-relaxed mb-3">
            走査型電子顕微鏡（SEM）による表面観察では、24時間後から針状結晶の生成が確認され、時間経過とともに結晶が粗大化・緻密化する様子が捉えられました。EDS分析により、これらの結晶は主に硫化銅（Cu2S）であり、一部に硫酸銅（CuSO4）が混在していることが確認されました。
          </p>
        </div>

        <div>
          <h3 class="text-lg font-bold text-foreground-900 mb-3">考察</h3>
          <p class="text-foreground-700 leading-relaxed mb-3">
            本試験結果から、銅は硫化水素を含む混合ガス環境下で比較的短期間（24時間以内）から腐食が進行し、接触信頼性に影響を及ぼすことが確認されました。特に高湿度環境（80%RH）では水分が触媒的に作用し、腐食反応が加速されることが示唆されます。
          </p>
          <p class="text-foreground-700 leading-relaxed mb-3">
            銅クーポンを用いた重量変化モニタリングは、ガス腐食試験の妥当性確認や試験機の性能検証に有効な手法であり、定期的なモニタリング用標準試験片としての活用が推奨されます。
          </p>
        </div>

        <div>
          <h3 class="text-lg font-bold text-foreground-900 mb-3">補足情報</h3>
          <div class="bg-background-100 rounded-lg p-4 space-y-1 font-mono text-sm text-foreground-900">
            <p>主な腐食反応式：</p>
            <p>2Cu + 2H2S + O2 → 2CuS + 2H2O</p>
            <p>Cu + SO2 + O2 → CuSO4</p>
            <p>2Cu + 2H2S + SO2 + 2O2 → Cu2S + CuSO4 + 2H2O</p>
          </div>
          <p class="text-foreground-700 text-sm mt-3">
            ※ 詳細な試験データ、グラフ、SEM画像についてはPDF報告書をご参照ください。
          </p>
        </div>
      </div>
    `
  },
  {
    id: "gas-corrosion-acceleration",
    title: "ガス腐食試験と加速率",
    author: "ファクトケイ株式会社 技術顧問 佐野誠",
    category: "技術レポート",
    summary: "コネクター、スイッチなど接触機構部品の長期的な信頼性を評価する為に、様々な環境試験が実施されていますが、特にガス腐食試験がこれらの評価に適しています。数々のガス腐食試験規格があり、実際の環境と比較してどれだけの加速係数を持っているのかという疑問について、各方面で実施検討されている事例などを含めて考察しています。",
    contentHtml: `
      <div class="space-y-6">
        <div>
          <p class="text-foreground-700 leading-relaxed mb-3">
            コネクター、スイッチなど接触機構部品の長期的な信頼性を評価する為に、様々な環境試験が実施されていますが、特にガス腐食試験がこれらの評価に適していると思います。しかし、数々のガス腐食試験規格があり、これらが実際の環境と比較してどれだけの加速係数を持っているのかという疑問が多く聞かれます。
          </p>
          <p class="text-foreground-700 leading-relaxed mb-3">
            私どもではある程度(体験的)な話は出来ますが、データーで表せと言われればお断りしなければならないほど現実的にはまだこれからの課題であって、おそらく結論が出るのは相当先の話となるでしょう。
          </p>
          <p class="text-foreground-700 leading-relaxed">
            実際あった話なのですが「以前、実施した試験では何も腐食は観られなかったが今回の試験結果をみると腐食が激しく試験機がおかしいのではないか?」と言う様な話を聞く事があります。確かに試験槽の中で部品のセット状態により若干ですが腐食度合いが違う場合がありますが、それより大きなファクターとして次のようなことがあげられ、上記のような質問が聞かれるものと確信致します。
          </p>
        </div>

        <div>
          <h3 class="text-lg font-bold text-foreground-900 mb-3">試験における注意点</h3>
          <p class="text-foreground-700 leading-relaxed mb-3">
            メッキサンプルは同じロットの中でも各々腐食の表れかたが違います。ましてロットが違い製造日が数ヶ月も違う様な物ではとても比較にはならないほどです。ですから、現行の試験はあくまで比較試験と考え、前に実施したからと言って安心していないで品質管理の一貫としてガス腐食試験が有用であると考える事が重要です。自然環境中には微量ですが色々なガスが含まれ、場所によってかなり高濃度の腐食性ガスが存在したりしております。また密閉された物のなかにも発生要因が存在すれば密閉の意味が無くなってきます。
          </p>
          <p class="text-foreground-700 leading-relaxed mb-3">
            始めにガス腐食試験が評価として適していると書きましたが、シングルガスとミックスガスではそれらの結果は大分違ってきます。
          </p>
          <p class="text-foreground-700 leading-relaxed mb-3">
            一般に銀、銅などは硫化水素が強い腐食性を持っておりますし、金メッキなどは水分と一緒になって酸性となる二酸化イオウ、二酸化窒素などの使用が推奨されています。しかし、実際の環境では濃度はかなり低いものの窒素酸化物、二酸化イオウ、硫化水素、塩素、アンモニア、ホルムアルデヒドなどが存在し、また周辺材料などから発生しています。
          </p>
          <p class="text-foreground-700 leading-relaxed mb-3">
            ですから、シングルガスでの影響を充分把握した上でバテル規格などの低濃度3種混合試験などを実施すれば一般自然環境下の使用に対して特に再現性に優れていると思われます。しかし、中には特殊な条件下で使用される部品もあり、試験温度が高かったり濃度が高かったり様々です。
          </p>
          <p class="text-foreground-700 leading-relaxed">
            同時に接触機構部品は本来機能部品ですから使用環境ほか各々の特性からガスの作用を受けやすい物も、そうでない物も存在します。ですから、そのような部品の接触信頼性に付いて加速係数を論じるのはそれほど簡単ではないという事がおわかり頂けると思いますが、各方面で実施検討されている事例などを含め、述べたいと思います。
          </p>
        </div>

        <div>
          <h3 class="text-lg font-bold text-foreground-900 mb-3">基本データとサンプルの問題点</h3>
          <p class="text-foreground-700 leading-relaxed mb-3">
            まず基本データーを取る為に一般的には実際の部品を屋外、屋内など各場所に設置、少なくとも10年間位にわたって放置し、この間、何回も莫大なデーターを収集したものが基本となってまいりますが、まだ完全に確立されていないのが現状です。(ベル研でも過去莫大なデーターを蓄積した筈ですが、世間にフィードバックされた物は極僅かであると思います)
          </p>
          <p class="text-foreground-700 leading-relaxed mb-3">
            これは接触機構部品の特性上、止むを得ない事だと考えられます。なぜかといえば接触機構一つを取っても非常にセンシビティであるという事です。たとえば銅板のガス腐食試験と接触抵抗の関係を測定しようとした場合、数時間のガス腐食試験でもかなりピークに近い様な値になってしまいますし、純銀のようなサンプルでも塩素ガスなどの試験でやはり数時間で高い値を示します。
          </p>
          <p class="text-foreground-700 leading-relaxed mb-3">
            金メッキサンプルなどは部分的に腐食が違う為、接触機構の評価はかなり複雑になってきます。それらのことから標準になるバラツキの無いサンプルを作るのは殆ど不可能に近い事ではないでしょうか。
          </p>
          <p class="text-foreground-700 leading-relaxed mb-3">
            事実99.9999%純金板の表面にも極僅かですが銅、銀の硫化物が観られ、接触抵抗の観点からみれば標準サンプルとして使うのは一考する必要があることがわかります。また、これらの微妙な被膜を介在した接触抵抗評価も被膜を壊さないで測定できるかどうかなど数々のノウハウがあります。
          </p>
          <p class="text-foreground-700 leading-relaxed">
            これはある程度定量できるサンプルでの話なのですが、実際の製品になった場合、話は更に複雑になってきます。構造、材質、バラツキなどによりガス腐食の影響がかなり変わってくると思われますし、実際の部品では接触抵抗の変化を捕らえることはかなり難しくなってきます。
          </p>
        </div>

        <div>
          <h3 class="text-lg font-bold text-foreground-900 mb-3">気体濃度と皮膜厚さの関係</h3>
          <p class="text-foreground-700 leading-relaxed mb-3">
            まず、気体濃度(H2S)と被膜の厚さと放置時間の関係を表すグラフですが、濃度が高いからそれに比例して膜厚が厚くなると思っていては間違いです。それに低濃度でゆっくり出来た皮膜と高濃度で早く作られた被膜を接触抵抗で比較すると違いがあります。それに単一ガスと複数の混合ガスではかなりの違いが表れます。
          </p>
          <div class="my-4">
            <img src="https://www.factk.jp/factk/images/gashp2.gif" alt="AgのH2Sによる腐食過程に及ぼす湿度の影響" class="w-full max-w-lg mx-auto rounded-lg" />
          </div>
        </div>

        <div>
          <h3 class="text-lg font-bold text-foreground-900 mb-3">銅片の腐食による重量変化</h3>
          <p class="text-foreground-700 leading-relaxed mb-3">
            次は決められた金属片の前処理後の重量を高感度天秤で測定し腐食の重量変化を表すグラフ(2)を示しますが、試験サンプルの面積による違いはあるが、前処理、材料などの条件を充分検討すれば腐食試験のモニターとして使用可能かと思います。ただし、塩類の生成を来たすような試験条件下などでは関連性がわかりにくくなる恐れがあります。
          </p>
          <div class="my-4">
            <img src="https://www.factk.jp/factk/images/image6.gif" alt="銅片の腐食による重量変化グラフ" class="w-full max-w-2xl mx-auto rounded-lg" />
          </div>
        </div>

        <div>
          <h3 class="text-lg font-bold text-foreground-900 mb-3">加速試験とフィールド試験の相関性</h3>
          <p class="text-foreground-700 leading-relaxed mb-3">
            グラフ3は加速試験とフィールド試験との相関性を皮膜厚さで評価した結果です。フィールドデーターはバラツキが当然大きく、原因として次のようなものが挙げられます。
          </p>
          <ul class="list-disc pl-5 space-y-1 text-foreground-700 leading-relaxed mb-3">
            <li>1. 場所による湿度の違い</li>
            <li>2. 大気中硫化水素濃度の違い</li>
            <li>3. 温度のバラツキ</li>
            <li>4. 他の気体や塵埃などの混在</li>
            <li>5. 試料表面の状態や初期表面の清浄度</li>
            <li>6. 試料の純度(Cu, Feの混在)</li>
            <li>7. 光の当たる場所かどうかなど</li>
          </ul>
          <p class="text-foreground-700 leading-relaxed mb-3">
            このデーターから0.01ppmの硫化水素濃度で湿度75%RHの条件をフィールドデーターと見なして、15ppmの硫化水素の加速試験との間で加速率をみると、次のようになる。すなわち皮膜厚さを300Åとすると、15ppm H2Sでは100時間かかり、0.01ppmでは1000時間かかるので、その比率は単純に考えれば10しかなく、実際の部品ともなれば皮膜の破壊性が強い為、特に過酷な試験とはなり得ないのである。
          </p>
          <div class="my-4">
            <img src="https://www.factk.jp/factk/images/image7.gif" alt="Agの汚染カイネティクスに対する加速試験とフィールド試験の比較グラフ" class="w-full max-w-2xl mx-auto rounded-lg" />
          </div>
        </div>

        <div>
          <h3 class="text-lg font-bold text-foreground-900 mb-3">混合ガスによる接触抵抗データ</h3>
          <p class="text-foreground-700 leading-relaxed mb-3">
            最後に皮膜を殆ど破壊しない方法で混合ガスによる接触抵抗をとらえたデーターを最後のグラフ4に示します。
          </p>
          <div class="my-4">
            <img src="https://www.factk.jp/factk/images/image8.gif" alt="各種ガスによる接触抵抗変化グラフ" class="w-full max-w-2xl mx-auto rounded-lg" />
          </div>
          <p class="text-foreground-700 text-sm">
            参考文献: 接触技術の基礎と接触信頼性、向上と対策 / 三重大学院 玉井 輝雄氏
          </p>
        </div>
      </div>
    `
  },
  {
    id: "temp-humidity-gas-control",
    title: "温湿度プログラム制御記録とガス濃度制御の紹介",
    author: "ファクトケイ株式会社",
    category: "技術資料",
    summary: "25℃60%〜65℃95%のサイクル試験時の結露評価とガス濃度連続測定の記録を紹介。KG130ガス濃度制御ユニットによる温湿度プログラム制御と、流量変化に対する槽内ガス濃度の安定した自動制御のデータを掲載しています。",
    contentHtml: `
      <div class="space-y-6">
        <div>
          <h3 class="text-lg font-bold text-foreground-900 mb-3">テストの目的</h3>
          <p class="text-foreground-700 leading-relaxed">25℃60%~65℃95%のサイクル試験時の結露評価とガス濃度連続測定</p>
        </div>

        <div>
          <h3 class="text-lg font-bold text-foreground-900 mb-3">方法</h3>
          <p class="text-foreground-700 leading-relaxed mb-3">
            試験槽内にテストパターンを写した鏡を設置し、温湿度と制御値を同時記録しました。
          </p>
          <div class="grid grid-cols-1 sm:grid-cols-3 gap-4 my-4">
            <div class="text-center">
              <img src="https://www.factk.jp/factk/images/chamber1.gif" alt="温湿度制御装置のセッティング" class="w-full rounded-lg" />
              <p class="text-xs text-foreground-600 mt-2">セットの様子を外ドアを開けて撮影</p>
            </div>
            <div class="text-center">
              <img src="https://www.factk.jp/factk/images/testviwmini.gif" alt="鏡の前にカメラとテストパターン" class="w-full rounded-lg" />
              <p class="text-xs text-foreground-600 mt-2">鏡とカメラとテストパターン</p>
            </div>
            <div class="text-center">
              <div class="bg-background-100 rounded-lg p-4 h-full flex items-center justify-center">
                <p class="text-sm text-foreground-700">曇り止め処理がされていない鏡を使用して曇ると左半分が見えなくなります</p>
              </div>
            </div>
          </div>
        </div>

        <div>
          <h3 class="text-lg font-bold text-foreground-900 mb-3">結露の観察結果</h3>
          <div class="grid grid-cols-1 sm:grid-cols-2 gap-4 my-4">
            <div class="text-center">
              <img src="https://www.factk.jp/factk/images/chamberin03.gif" alt="内ドア内に小さな結露" class="w-full max-w-xs mx-auto rounded-lg" />
              <p class="text-xs text-foreground-600 mt-2">内ドアステー部に小さな結露</p>
            </div>
            <div class="text-center">
              <img src="https://www.factk.jp/factk/images/chamberin02.gif" alt="試験槽天井内に結露なし" class="w-full max-w-xs mx-auto rounded-lg" />
              <p class="text-xs text-foreground-600 mt-2">試験槽天井内に結露なし</p>
            </div>
          </div>
          <p class="text-foreground-700 leading-relaxed">
            水分に溶けやすいガスは試験槽内の水分に吸着するとガス濃度の不安定の原因や吸着した水分で加湿すればフィールドとは別の試験条件になってしまいます。KG130は試験槽内の結露や水面積を極力無くす事により安定した条件の試験が可能です。また槽内はテフロン処理されているのでガスの吸着が少なく、試験毎に洗浄しなくても高濃度から低濃度まで試験可能です。
          </p>
        </div>

        <div>
          <h3 class="text-lg font-bold text-foreground-900 mb-3">温湿度の記録とデータ動画</h3>
          <div class="space-y-6 my-4">
            <div class="text-center">
              <p class="text-sm text-foreground-800 mb-2 font-medium">湿度下降を可能な限り追従させた記録</p>
              <img src="https://www.factk.jp/factk/images/temphumtest5.gif" alt="湿度下降を可能な限り追従したチャート" class="w-full max-w-2xl mx-auto rounded-lg" />
              <p class="text-xs text-foreground-600 mt-1">時間(分)</p>
            </div>
            <div class="text-center">
              <p class="text-sm text-foreground-800 mb-2 font-medium">早めに除湿を行なった記録</p>
              <img src="https://www.factk.jp/factk/images/temphumtest6.gif" alt="早めに除湿を行ったチャート" class="w-full max-w-2xl mx-auto rounded-lg" />
              <p class="text-xs text-foreground-600 mt-1">時間(分)</p>
            </div>
          </div>
        </div>

        <div>
          <h3 class="text-lg font-bold text-foreground-900 mb-3">ガス濃度測定と自動制御の紹介</h3>
          <p class="text-foreground-700 leading-relaxed mb-3">
            流量変化に対する槽内ガス濃度記録を以下に示します。
          </p>
          <div class="text-center my-4">
            <img src="https://www.factk.jp/factk/images/gasconcentration.gif" alt="流量変化に対する槽内ガス濃度記録" class="w-full max-w-2xl mx-auto rounded-lg" />
          </div>
          <div class="text-center my-4">
            <img src="https://www.factk.jp/factk/images/gascon_graf.gif" alt="ガス濃度グラフ" class="w-full max-w-lg mx-auto rounded-lg" />
          </div>
        </div>

        <div>
          <h3 class="text-lg font-bold text-foreground-900 mb-3">KG130ガス濃度制御ユニット</h3>
          <div class="grid grid-cols-1 sm:grid-cols-2 gap-4 my-4">
            <div class="text-center">
              <img src="https://www.factk.jp/factk/images/gascontpanel.gif" alt="KG130ガス濃度制御ユニット" class="w-full max-w-md mx-auto rounded-lg" />
            </div>
            <div class="flex flex-col justify-center space-y-2 text-sm text-foreground-700">
              <p>温度表示設定・温度補整・オート/マニュアル切り替え・校正・その他</p>
              <p>制御設定キー</p>
              <p>パージ・制御・停止SW</p>
              <p>ガス流量表示</p>
              <p>マニュアル流量制御設定ダイヤル</p>
            </div>
          </div>
        </div>
      </div>
    `
  },
  {
    id: "corrosive-gas-reaction",
    title: "硫化水素、二酸化イオウなど腐食性ガスの作用",
    author: "ファクトケイ株式会社",
    category: "技術レポート",
    summary: "二酸化イオウ(SO2)と硫化水素(H2S)による金属腐食の化学反応メカニズムについて解説。金(Au)表面や銅・ニッケル下地金メッキ表面での生成物反応、金属の汚染機構における水分の影響について詳しく説明しています。",
    contentHtml: `
      <div class="space-y-6">
        <div>
          <h3 class="text-lg font-bold text-foreground-900 mb-3">二酸化イオウ(SO2)の腐食作用</h3>
          <p class="text-foreground-700 leading-relaxed mb-3">
            二酸化イオウ(SO2)は単体で強い腐食性は無いが湿度が上がりH2Oが作用し、H2SO3(酸性)となる。
          </p>
          <h4 class="text-base font-semibold text-foreground-900 mt-4 mb-2">金(Au)表面に出来る生成物反応</h4>
          <div class="bg-background-100 rounded-lg p-4 mb-3 space-y-1 font-mono text-sm text-foreground-900">
            <p>SO2 + H2O -----> H2SO3(亜硫酸)</p>
            <p>SO2 + NO2 -----> NO + SO3</p>
            <p>SO3 + H2O -----> H2SO4(硫酸)</p>
            <p>H2SO4 + NH3 -----> (NH4)2SO4(硫酸アンモニウム)</p>
          </div>
          <h4 class="text-base font-semibold text-foreground-900 mt-4 mb-2">銅、ニッケル下地金メッキ表面に生成可能な金属塩例</h4>
          <p class="text-foreground-700 leading-relaxed mb-3">
            NiSO4, CuSO4, NiNO3, Cu(NO3)2, その他の金属塩
          </p>
        </div>

        <div>
          <h3 class="text-lg font-bold text-foreground-900 mb-3">硫化水素(H2S)による腐食</h3>
          <p class="text-foreground-700 leading-relaxed mb-3">
            硫化水素(H2S)は銀(Ag)や銅(Cu)を激しく腐食させる気体です。H2SとAgの場合、次の様な反応式が成り立ちます。
          </p>
          <div class="bg-background-100 rounded-lg p-4 mb-3 space-y-1 font-mono text-sm text-foreground-900">
            <p>Ag -----> Ag+ + e-</p>
            <p>2H2S + O2 -----> 2S + H2O</p>
            <p>S + 2e- -----> S2-</p>
            <p>2Ag+ + S2- -----> Ag2S</p>
          </div>
          <div class="bg-background-100/70 rounded-lg p-3 mb-3">
            <p class="font-mono text-sm text-foreground-900">※ 4Ag + 2H2S + O2 -----> 2Ag2S + 2H2O</p>
            <p class="font-mono text-sm text-foreground-900">※ 2Cu + 2H2S + O3 -----> 2CuS + 2H3O</p>
          </div>
        </div>

        <div>
          <h3 class="text-lg font-bold text-foreground-900 mb-3">金属の汚染機構における水分の影響</h3>
          <p class="text-foreground-700 leading-relaxed mb-3">
            金属の汚染機構には水分の影響が大きく関わり、70%RH位を境として湿食(wet corrosion)となる。
          </p>
          <p class="text-foreground-700 leading-relaxed mb-3">
            大気中に含まれる湿度はある程度以上になると乾食から湿食になり、すなわち金属表面の吸着が多くなり水滴を形成する。また、大気空間であっても水蒸気の粒度が大きくなる。したがって汚染気体がこのような水分に溶解する傾向を示しミスト状態になる。(電解質水溶液が金属表面に吸着する)こうなると金属はイオンになって溶液中に溶け出し、水溶液中の溶質イオンと反応して汚染生成物が生ずる。
          </p>
        </div>

        <div>
          <h3 class="text-lg font-bold text-foreground-900 mb-3">イラスト：腐食メカニズム</h3>
          <div class="grid grid-cols-1 sm:grid-cols-2 gap-4 my-4">
            <div class="text-center">
              <img src="https://www.factk.jp/factk/images/gashp1.gif" alt="ピンホールを通してのガルバニ型表面汚染" class="w-full max-w-xs mx-auto rounded-lg" />
              <p class="text-xs text-foreground-600 mt-2">ピンホールを通してのガルバニ型表面汚染</p>
            </div>
            <div class="text-center">
              <img src="https://www.factk.jp/factk/images/gashp2.gif" alt="AgのH2Sによる腐食過程に及ぼす湿度の影響" class="w-full max-w-xs mx-auto rounded-lg" />
              <p class="text-xs text-foreground-600 mt-2">AgのH2Sによる腐食過程に及ぼす湿度の影響</p>
            </div>
          </div>
        </div>
      </div>
    `
  }
];